module.exports = __webpack_public_path__ + "media/images/fallback_file-8e0714c3bb3e3f9b04c1dd7c881e4308.png";